import { ITag } from "../../../../models/ITag";
import { IFile } from "../../../../models/IFile";
import { IWorkspaceLibraryDocument } from "../../../../components/manageWorkspaces/workspaceLibrary/workspaceLibrary.types";

export interface IWorkspaceManageContentProps {
  isOpen: boolean;
  isPersonalWorkspace: boolean;
  onClose: () => void;
  knowledgeComponents: ITag[];
  selectedKnowledgeComponents: ITag[];
  onKnowledgeComponentsChange: (tags: ITag[]) => void;
  workspaceDocuments: IWorkspaceLibraryDocument[];
  selectedWorkspaceDocuments: IWorkspaceLibraryDocument[];
  onWorkspaceDocumentsChange: (docs: IWorkspaceLibraryDocument[]) => void;
  uploadedDocuments: IFile[];
  onUploadedDocumentsChange: (files: IFile[]) => void;
  workspaceId?: string;
  onWorkspaceDocumentsRefresh?: () => Promise<void>;
  isLoadingKnowledgeComponents?: boolean;
  isLoadingWorkspaceDocuments?: boolean;
}

export interface IWorkspaceManageContentTabKey {
  KNOWLEDGE_COMPONENTS: "knowledgeComponents";
  WORKSPACE_DOCUMENTS: "workspaceDocuments";
}

export const WORKSPACE_MANAGE_CONTENT_TABS: IWorkspaceManageContentTabKey = {
  KNOWLEDGE_COMPONENTS: "knowledgeComponents",
  WORKSPACE_DOCUMENTS: "workspaceDocuments",
};

export interface IKnowledgeComponentGroup {
  categoryName: string;
  items: ITag[];
}

export interface ITabContentProps {
  knowledgeComponents: ITag[];
  selectedKnowledgeComponents: ITag[];
  onKnowledgeComponentsChange: (tags: ITag[]) => void;
  workspaceDocuments: IWorkspaceLibraryDocument[];
  selectedWorkspaceDocuments: IWorkspaceLibraryDocument[];
  onWorkspaceDocumentsChange: (docs: IWorkspaceLibraryDocument[]) => void;
  uploadedDocuments: IFile[];
  onUploadedDocumentsChange: (files: IFile[]) => void;
  workspaceId?: string;
  onWorkspaceDocumentsRefresh?: () => Promise<void>;
  isLoadingKnowledgeComponents?: boolean;
  isLoadingWorkspaceDocuments?: boolean;
}
